import { GeneratedContentStatus } from 'global/generatorsApi';

export interface Scene {
  id: string;
  name: string;
  preview: string;
}

export interface ScenesGroup {
  id: string;
  name: string;
  scenes?: Scene[];
}

export interface GeneratedContent {
  id: string;
  createdAt: string;
  prompt: string;
  negativePrompt: string;
  status: GeneratedContentStatus;
  objectName: string;
  styleId: string;
  sceneId: number;
}

export enum VectorizingSolver {
  binary = 0,
  color = 1,
}

export type VectorizeInfo = {
  error?: string;
  id: string;
  status: GeneratedContentStatus;
  objectName: string;
  info: {
    image_width: number;
    image_height: number;
    bounds: {
      top: number;
      left: number;
      width: number;
      height: number;
    };
  };
};

export interface ImageGenPayload {
  prompt: string;
  style?: number;
  signal: AbortSignal;
}
